module.exports = __webpack_public_path__ + "img/Weapon_141.8e4e3b33.png";